import React, { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { useLocation, useNavigate } from "react-router-dom";
import { validateAuthToken } from "../../apis/authToken";
import { getUserMeta } from "../../apis/user";
import LoadingScreen from "../../components/LoadingScreen";

const AuthGuard = ({
  Component,
  requireLogin = false,
  requireNotLogin = false,
  requireRole = [5],
  ...rest
}) => {
  const [cookies, setCookie] = useCookies(["access_token", "user_info"]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    setLoading(true);

    if (cookies.access_token) {
      validateAuthToken(cookies.access_token)
        .then(async (authResult) => {
          await redirectToValidRoute(authResult.status === 200);
        })
        .catch((e) => console.error);
    } else {
      redirectToValidRoute(false);
    }
  }, [cookies.access_token]);

  const redirectToValidRoute = async (auth) => {
    let expires = new Date();
    expires.setTime(expires.getTime() + 7 * 24 * 60 * 60 * 1000);

    if (auth && !location.pathname.includes("profile")) {
      const result = await getUserMeta(cookies.access_token);
      setCookie("user_info", JSON.stringify(result.data), {
        path: "/",
        expires: expires,
        maxAge: 7 * 24 * 60 * 60,
        secure: true,
        sameSite: "strict",
      });

      if (!requireRole.includes(result.data.role)) {
        if ([2, 1, 0].includes(result.data.role) && !location.pathname.includes("admin")) navigate("/admin")
        if (result.data.role === 4 && location.pathname.includes("seller/register")) navigate("/seller")
        if (result.data.metadata === null) navigate("/user")
        if (location.pathname === "/" || location.pathname === "/login") navigate("/home")
      } else if (requireRole.some((element) => [2, 1, 0].includes(element))) navigate("/admin")
      else {
        if (result.data.metadata === null) navigate("/user")
      }
    }

    if (requireLogin && !auth) {
      if (requireRole.some((element) => [2, 1, 0].includes(element))) navigate("/admin/login");
      // else if (requireRole.some((element) => [3, 4, 5].includes(element)))
      //   navigate("/home");
      else navigate("/login");
    }

    if (requireNotLogin && auth) {
      const result = await getUserMeta(cookies.access_token);
      setCookie("user_info", JSON.stringify(result.data), {
        path: "/",
        expires: expires,
        maxAge: 7 * 24 * 60 * 60,
        secure: true,
        sameSite: "strict",
      });

      if (
        !location.pathname.includes("profile") &&
        result.data.metadata === null
      )
        navigate("/user");
    }

    setLoading(false);
  };

  if (loading) {
    return <LoadingScreen />;
  }

  return <Component {...rest} />;
};

export default AuthGuard;
